/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/email" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsEmail } from "./constants";
import type { AppsAppGroupIdChartsEmailResult } from "./types";

export const getAppsAppGroupIdChartsEmail = reactQueryFetcherAdapter(
  appsAppGroupIdChartsEmail,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate: number,
    endDate: number
  ): Promise<AppsAppGroupIdChartsEmailResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/email`,
      "GET",
      { start_date: startDate, end_date: endDate },
      { signal }
    );
  }
);
